import React from 'react'
import './styles/linkButton.scss'
import { Link } from 'react-router-dom'

const LinkButton = (props) => {
    const {
        children, cssClass, onClick, label, icon, style,
        href, isExternal, disabled, target, customClass,
    } = props

    let componentClass = 'linkButton'
    componentClass += disabled ? 'disabled-link' : ''
    componentClass += icon ? ' icon-btn' : ''
    componentClass += cssClass ? ` ${cssClass}` : ''
    componentClass += customClass ? ` ${customClass}` : ''

    if (isExternal) {
        return (
            <a
                style={style}
                href={href}
                onClick={onClick}
                className={componentClass}
                target={target}
            >
                {icon ? <i className={icon} /> : null}
                {label}
                {children}
            </a>
        )
    }
    return (
        <Link style={style} to={href} onClick={onClick} className={componentClass}>
            {icon ? <i className={icon} /> : null}
            {label}
            {children}
        </Link>
    )
}

export default LinkButton
